import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import { getContractors } from "common/services/contractors.service";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";

const Contractors = () => {
  const selectProperties = createSelector(
    (state: any) => state.Contracts,
    (state) => ({
      ltaSummary: state.ltaSummary,
    })
  );

  const { ltaSummary } = useSelector(selectProperties);

  return (
    // <Card className="card-animate">
    //   <CardBody>
    //     <div className="d-flex align-items-center">
    //       <div className="flex-grow-1 overflow-hidden">
    //         <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
    //           Contractors
    //         </p>
    //       </div>
    //     </div>
    //     <div className="d-flex align-items-end justify-content-between mt-4">
    //       <div>
    //         <h4 className="fs-22 fw-semibold ff-secondary mb-4">
    //           <span className="counter-value" data-target="559.25">
    //             <CountUp
    //               start={0}
    //               prefix={""}
    //               suffix={""}
    //               separator={""}
    //               end={meta?.pagination?.total}
    //               decimals={0}
    //               duration={2}
    //             />
    //           </span>
    //         </h4>
    //         <Link to="/contractors" className="text-decoration-underline">
    //           View all contractors
    //         </Link>
    //       </div>
    //       <div className="avatar-sm flex-shrink-0">
    //         <span className={"avatar-title rounded fs-3 bg-warning-subtle"}>
    //           <i className={`text-warning bx bx-user-circle`}></i>
    //         </span>
    //       </div>
    //     </div>
    //   </CardBody>
    // </Card>

    <Card className="card-animate">
      <CardBody>
        <div className="d-flex justify-content-between">
          <div>
            <p className="fw-medium text-muted mb-0">Contractors</p>
            <h2 className="mt-4 ff-secondary fw-semibold fs-22">
              <span className="counter-value">
                <CountUp
                  start={0}
                  prefix={""}
                  suffix={""}
                  separator={""}
                  end={ltaSummary?.totalContractors || 0}
                  decimals={0}
                  duration={2}
                />
              </span>
            </h2>
            {/* <p className="mb-0 text-muted">
        <span className={"badge bg-light mb-0 text-success"}>
          <i className={"align-middle "}></i>{" "}
        </span>{" "}
        vs. previous month
      </p> */}
          </div>
          <div>
            <div className="avatar-sm flex-shrink-0">
              <span
                className={
                  "avatar-title rounded-circle fs-4 bg-warning" +
                  "-subtle text-warning"
                }
              >
                <i className={"bx bx-user-circle"}></i>
              </span>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default Contractors;
